define.alias("ember-math-helpers/helpers/log2", "settings/helpers/log2");